import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const scroll = (behavior) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior, block: 'start' });
      };
      requestAnimationFrame(() => setTimeout(() => scroll(reduced ? 'auto' : 'smooth'), 50));
      const settle = setTimeout(() => scroll('auto'), 900);
      return () => clearTimeout(settle);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
